import { useEffect } from "react";
import { t } from "i18next";
import { useHistory } from "react-router-dom";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import ApiService from "../../../core/service/ApiService";
import Helper from "../../../core/Helper";
import PatientFilter from "./PatientFilter";
import {Button} from "antd";

export default function PatientGrid() {
    const history = useHistory();
    const { queryModel, setDataGridProps, setData, setPaginationResult, refreshDataGrid } = useDataGrid();


    const birthDate = (d, m, y) => {
        if (d)
            return `${d}/${m}/${y}`

        return '-'
    }

    const openPatientResults = async (row) => {
        const res = await ApiService.Patient.GetToken(row.id);
        if(res.success) {
            const url = `${window.AppSettings.server.result}?access_token=${res.data}`
            window.open(url, '_blank')
        }
    }

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: [
                { dataIndex: 'customId', key: 'customId', title: t('Patient Id'), sorter: true, render: (text, row) => text || '-' },
                { dataIndex: 'name', key: 'name', title: t('Name'), sorter: true, render: (text, row) => <a target={'_blank'} href={(`/app/patients/${row.id}/appointments`)}>{text}</a> },
                { dataIndex: 'lastname', key: 'lastname', title: t('Lastname'), sorter: true },
                { dataIndex: 'motherName', key: 'motherName', title: t('Mother Name'), sorter: true, render: (text) => text || '-' },
                { dataIndex: 'fatherName', key: 'fatherName', title: t('Father Name'), sorter: true, render: (text) => text || '-' },
                { dataIndex: 'birthdate', key: 'birthdate', title: t('Birthdate'), render: (text, row) => birthDate(row.birthDay, row.birthMonth, row.birthYear) },
                { dataIndex: 'gender', key: 'gender', title: t('Gender'), sorter: true, render: (text, row) => t(text || '-') },
                { dataIndex: 'phone1', key: 'phone1', title: t('Phone') },
                { dataIndex: 'balance', key: 'balance', title: t('Balance'), sorter: true, render: (text, row) => t(Helper.Currency.format(text) || '-') },
                { dataIndex: '#', key: '#', title: t('#'), sorter: true, render: (text, row) => {
                    return (
                        <Button
                            disabled={!row?.validate}
                            size={'small'}
                            onClick={() => openPatientResults(row)}
                        >
                            {t('Patient Results')}
                        </Button>
                    )
                }},
            ]
        })
    }, [])

    const load = async () => {
        const res = await ApiService.Patient.GetPatientDataGrid(queryModel);
        if (res.success) {
            setData(res.data)
            setPaginationResult(res.pagination);
        }
    }

    useEffect(() => {
        load()
    }, [queryModel.updateKey])

    return (
        <>
            <DataGrid
                title={() => (<PatientFilter />)}
            />
        </>
    )
}